// extracted by mini-css-extract-plugin
export var chevron = "_1q-d";
export var disabled = "_1q-b";
export var error = "_1q-c";
export var hideBorder = "_1q-1";
export var icon = "_1q-e";
export var input = "_1q-0";
export var large = "_1q-f";
export var open = "_1q-9";
export var placeholder = "_1q-a";
export var regular = "_1q-5";
export var singleRowInput = "_1q-2";
export var singleSelectInput = "_1q-3 _1q-0";
export var small = "_1q-4";
export var spinnerContainer = "_1q-i";
export var tag = "_1q-7";
export var tagsContainer = "_1q-8";
export var tagsInput = "_1q-6 _1q-0";
export var xSmall = "_1q-g";
export var xxSmall = "_1q-h";